import dayjs from "dayjs"
import { z } from "zod"

export const CALLER_TYPES = ["user", "store", "other"] as const

export type CallerType = (typeof CALLER_TYPES)[number]

export const CALLER_TYPE_LABELS: Record<CallerType, string> = {
  user: "ユーザー",
  store: "加盟店",
  other: "その他",
}

export type IncomingCallLog = {
  id: number
  userId: number | null
  storeId: number | null
  callerType: CallerType
  callerNote: string | null
  receivedAt: string
  responderName: string
  content: string
  nextAction: string | null
  createdAt: string
  updatedAt: string
}

export const incomingCallLogFormSchema = z.object({
  callerType: z.enum(CALLER_TYPES),
  callerNote: z.string().max(255, "相手の付属情報は255文字以内で入力してください"),
  userId: z.string().trim().regex(/^\d*$/, "ユーザーIDは数字で入力してください"),
  storeId: z.string().trim().regex(/^\d*$/, "店舗IDは数字で入力してください"),
  receivedAt: z.string().min(1, "受電日時を入力してください"),
  content: z
    .string()
    .trim()
    .min(1, "会話の内容を入力してください")
    .max(10000, "会話の内容は10000文字以内で入力してください"),
  nextAction: z.string().max(2048, "ネクストアクションは2048文字以内で入力してください"),
})

export type IncomingCallLogFormValues = z.infer<typeof incomingCallLogFormSchema>

/** フォームの値を、受電ログの追加・更新 API に送る形にする */
export const toIncomingCallLogRequestBody = (values: IncomingCallLogFormValues) => ({
  incomingCallLog: {
    userId: values.userId || null,
    storeId: values.storeId || null,
    callerType: values.callerType,
    callerNote: values.callerNote,
    // datetime-local の値はタイムゾーンを持たないので、ブラウザのオフセット付きで送る
    receivedAt: dayjs(values.receivedAt).format(),
    content: values.content,
    nextAction: values.nextAction,
  },
})
